export const howItWorks = [
  {
    step: "1",
    title: "Select Your Instrument",
    description:
      "Choose from forex pairs, commodities, or indices to get precise calculations.",
    icon: "bi-bullseye",
  },
  {
    step: "2",
    title: "Enter Your Parameters",
    description:
      "Input your account balance, risk percentage, and other trade details.",
    icon: "bi-gear-fill",
  },
  {
    step: "3",
    title: "Get Instant Results",
    description:
      "Receive precise calculations to optimize your trading strategy.",
    icon: "bi-lightning-fill",
  },
];
